import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger' | 'success';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  loading?: boolean;
  icon?: React.ReactNode;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  loading = false,
  icon,
  children,
  className = '',
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'btn-base transition-smooth font-semibold';
  const variants = {
    primary: 'bg-cyan-500 text-slate-950 hover:bg-cyan-400 hover:shadow-glow active:scale-95 focus-visible:ring-cyan-500',
    secondary: 'bg-slate-800 text-slate-100 hover:bg-slate-700 border border-slate-700 hover:border-slate-600 active:scale-95 focus-visible:ring-slate-500',
    outline: 'bg-transparent text-cyan-500 border-2 border-cyan-500 hover:bg-cyan-500/10 hover:shadow-glow active:scale-95 focus-visible:ring-cyan-500',
    ghost: 'bg-transparent text-slate-300 hover:bg-slate-800 hover:text-slate-100 active:scale-95 focus-visible:ring-slate-500',
    danger: 'bg-red-500 text-white hover:bg-red-400 hover:shadow-[0_0_20px_rgba(239,68,68,0.3)] active:scale-95 focus-visible:ring-red-500',
    success: 'bg-green-500 text-white hover:bg-green-400 hover:shadow-[0_0_20px_rgba(34,197,94,0.3)] active:scale-95 focus-visible:ring-green-500'
  };
  const sizes = {
    sm: 'px-3 py-1.5 text-sm rounded-lg',
    md: 'px-4 py-2 text-base rounded-xl',
    lg: 'px-6 py-3 text-lg rounded-xl',
    xl: 'px-8 py-4 text-xl rounded-2xl'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const disabledClass = disabled || loading ? 'opacity-50 cursor-not-allowed' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${disabledClass} ${className}`} disabled={disabled || loading} {...props} data-id="element-644">
      {loading ? <>
          <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-645" />
          Loading...
        </> : <>
          {icon && <span className="mr-2" data-id="element-646">{icon}</span>}
          {children}
        </>}
    </button>;
}